// Copy and naming for the on-demand Quotation Details Word file (#1448), in one place so a future
// second surface can't drift from the editor's copy. Mirrors resultCsv.constants.ts /
// resultPdf.constants.ts; the Word build is asynchronous (see detailsWord.helper.ts / the quotations
// hook), which is why this also carries poll timing the CSV flow has no analog for.
export const DETAILS_WORD_MESSAGES = {
	menuItem: "Download quotation details (Word)",
	pending: "Preparing Word file…",
	// Shown once the build is done and the file itself is transferring — a separate phase from
	// `pending`, matching the annotated result PDF's own "Downloading…" phase (#1401 review).
	downloading: "Downloading Word file…",
	success: "Word file downloaded",
	// Shown when a save was still travelling when generation started and did not land in time, so the
	// file may be a revision behind. Better than claiming a clean success.
	successMaybeStale: "Word file downloaded, but a recent change may be missing from it.",
	submitted: "This quotation is submitted — its result files are in the files list.",
	forbidden: "You don't have access to this quotation's Word file.",
	notFound: "This quotation no longer exists.",
	unauthorized: "Your session has expired. Sign in again to download the Word file.",
	failed: "Word file couldn't be generated. Try again.",
	timedOut: "Word file is taking too long. Try again in a moment.",
} as const

// Per-name cap for the composed download name. Two user-entered names plus the joiner have to fit
// inside the ~255-byte limit every common file system enforces, with room for a browser's " (1)"
// de-duplication suffix.
export const DETAILS_WORD_NAME_PART_MAX_LENGTH = 80

// How long to let in-flight autosaves finish before generating the Word file. Short: the file is
// worth a brief wait, but not a visibly stuck menu.
export const DETAILS_WORD_SAVE_FLUSH_TIMEOUT = 5000

// The spec (backend PR #2211) says to poll "every ~3 s".
export const DETAILS_WORD_POLL_INTERVAL_MS = 3000

// Generous cap on the whole poll loop, sized like the annotated result PDF's own ceiling. A build
// measured ~18s against the dev backend, so this only bites on a genuinely stuck job.
export const DETAILS_WORD_POLL_TIMEOUT_MS = 10 * 60 * 1000
